module.exports = __webpack_public_path__ + "/static/industry.png";